import { brand } from "services/envService";

export const Header = () => {
  const BRAND = brand();
  return (
    <>
      <div className="zb-masthead-container">
        <header className="zb-masthead">
          <div className="header-container">
            <div className="header-left-container">
              <span className={`zb-masthead-${BRAND}-logo`} />
              <span className="additional-text">Bounce Back Loan</span>
            </div>
          </div>
        </header>
      </div>
    </>
  );
};
